<!--  -->
<template>
  <div class="question" id="apply">
    <div id="header" class="header fn-clear opacity">
      <div class="centerline">
        <a href class="logo fl">
          <img src="./../assets/images/footer_logo@2x.png" alt />
        </a>
        <div class="tab fr btn-group">
          <router-link to="/home" class="btn">首页</router-link>
          <router-link to="/guide" class="btn">申请指南</router-link>
          <router-link to="/way" class="btn">管理办法</router-link>
          <router-link to="/question" class="btn">常见问题</router-link>
          <router-link to="/news" class="btn">新闻</router-link>
        </div>
      </div>
    </div>
    <div class="applybox">
      <div class="tit">
        <p class="title">基石奖申报</p>
        <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
      </div>
      <div class="toptab">
        <a href="javascript:;" :class="{'sure':this.tab==1}" @click="tab=1">专家推荐</a>
        <a href="javascript:;" :class="{'sure':this.tab==2}" @click="tab=2">自荐</a>
      </div>
      <div class="formbox">
        <div class="fn-clear" v-show="this.tab==1">
          <div class="fl inputbox">
            <span class="tit">专家姓名</span>
            <input
              :class="{'err':form.zjxm.state==false}"
              type="text"
              placeholder="请输入（必填）"
              v-model="form.zjxm.desc"
              @blur="fun('zjxm',form.zjxm.desc)"
            />
            <p class="tip" v-show="form.zjxm.state==false">{{this.form.zjxm.message}}</p>
          </div>
          <div class="fl inputbox">
            <span class="tit">联系电话</span>
            <input
              :class="{'err':form.zjlxdh.state==false}"
              type="text"
              placeholder="请输入（必填）"
              v-model="form.zjlxdh.desc"
              @blur="fun('zjlxdh',form.zjlxdh.desc)"
            />
            <p class="tip" v-show="form.zjlxdh.state==false">{{this.form.zjlxdh.message}}</p>
          </div>
        </div>
        <div class="formtit">
          <span class="icon arrow"></span>个人信息
          <em>必填</em>
        </div>
        <div class="form fn-clear">
          <div class="fl inputbox">
            <span class="tit">姓名</span>
            <input
              :class="{'err':form.name.state==false}"
              type="text"
              placeholder="请输入（必填）"
              v-model="form.name.desc"
              @blur="fun('name',form.name.desc)"
            />
            <p class="tip" v-show="form.name.state==false">{{this.form.name.message}}</p>
          </div>
          <div class="fl inputbox">
            <span class="tit">国籍</span>
            <input
              :class="{'err':form.guoji.state==false}"
              type="text"
              placeholder="请输入（必填）"
              v-model="form.guoji.desc"
              @blur="fun('guoji',form.guoji.desc)"
            />
            <p class="tip" v-show="form.guoji.state==false">{{this.form.guoji.message}}</p>
          </div>
          <div class="fl inputbox">
            <span class="tit">性别</span>
            <select id="sub2" v-model="xingbie">
              <option value>请选择</option>
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
            <p class="tip" v-show="form.xingbie.state==false">{{this.form.xingbie.message}}</p>
          </div>
          <div class="fl inputbox">
            <span class="tit">出生日期</span>
            <myDatepicker id="myDatepicker1"
              @change="changeTime"
              :date="startTime"
              :option="timeoption"
              :limit="limit"
            ></myDatepicker>
          </div>
          <div class="fl inputbox">
            <span class="tit">证件类型</span>
            <select id="sub3" v-model="zhengjian">
              <option value>请选择</option>
              <option value="1">居民身份证</option>
              <option value="2">护照</option>
              <option value="3">台湾居民来往大陆通行证</option>
              <option value="4">港澳居民来往内地通行证</option>
              <option value="5">外国人永久居留身份证</option>
              <option value="6">港澳居民居住证</option>
              <option value="7">台湾居民居住证</option>
            </select>
            <p class="tip" v-show="form.zhengjian.state==false">{{this.form.zhengjian.message}}</p>
          </div>
          <div class="fl inputbox">
            <span class="tit">证件号码</span>
            <input
              type="text"
              placeholder="请输入（必填）"
              :class="{'err':form.zhengjianhaoma.state==false}"
              v-model="form.zhengjianhaoma.desc"
              @blur="fun('zhengjianhaoma',form.zhengjianhaoma.desc)"
            />
            <p
              class="tip"
              v-show="form.zhengjianhaoma.state==false"
            >{{this.form.zhengjianhaoma.message}}</p>
          </div>
          <div class="inputbox conline fl">
            <span class="tit">学习单位</span>
            <input
              type="text"
              placeholder="请输入（必填）"
              :class="{'err':form.xuexidanwei.state==false}"
              v-model="form.xuexidanwei.desc"
              @blur="fun('xuexidanwei',form.xuexidanwei.desc)"
            />
            <p class="tip" v-show="form.xuexidanwei.state==false">{{this.form.xuexidanwei.message}}</p>
          </div>
          <div class="inputbox fl">
            <span class="tit">专业</span>
            <input
              type="text"
              placeholder="请输入（必填）"
              :class="{'err':form.zhuanye.state==false}"
              v-model="form.zhuanye.desc"
              @blur="fun('zhuanye',form.zhuanye.desc)"
            />
            <p class="tip" v-show="form.zhuanye.state==false">{{this.form.zhuanye.message}}</p>
          </div>
          <div class="inputbox fl">
            <span class="tit">最高学位</span>
            <input
              type="text"
              placeholder="请输入（必填）"
              :class="{'err':form.zuigaoxuewei.state==false}"
              v-model="form.zuigaoxuewei.desc"
              @blur="fun('zuigaoxuewei',form.zuigaoxuewei.desc)"
            />
            <p
              class="tip"
              v-show="form.zuigaoxuewei.state==false"
            >{{this.form.zuigaoxuewei.message}}</p>
          </div>
          <div class="inputbox apply conline fl">
            <span class="tit">申报方向</span>
            <select id="sub4" v-model="shenbaofangxiang">
              <option value>请选择</option>
              <option value="1">中学</option>
              <option value="2">大学</option>
              <option value="3">研究生</option>
            </select>
            <p
              class="tip"
              v-show="form.shenbaofangxiang.state==false"
            >{{this.form.shenbaofangxiang.message}}</p>
          </div>
          <div class="inputbox fl">
            <span class="tit">联系电话</span>
            <input
              type="text"
              placeholder="请输入（必填）"
              :class="{'err':form.lianxidianhua.state==false}"
              v-model="form.lianxidianhua.desc"
              @blur="fun('lianxidianhua',form.lianxidianhua.desc)"
            />
            <p
              class="tip"
              v-show="form.lianxidianhua.state==false"
            >{{this.form.lianxidianhua.message}}</p>
          </div>
          <div class="inputbox fl">
            <span class="tit">邮箱</span>
            <input
              type="text"
              placeholder="请输入（必填）"
              :class="{'err':form.youxiang.state==false}"
              v-model="form.youxiang.desc"
              @blur="fun('youxiang',form.youxiang.desc)"
            />
            <p class="tip" v-show="form.youxiang.state==false">{{this.form.youxiang.message}}</p>
          </div>
        </div>
        <div class="formtit">
          <span class="icon arrow"></span>教育经历
          <em>必填</em>
          <span class="desc">按时间倒叙排序，至中学截止</span>
        </div>
        <div class="conform">
          <div class="title fn-clear">
            <div class="tit fl">起止年月</div>
            <div class="tit fl">校（院）、系及专业</div>
            <div class="tit fl">学位</div>
          </div>
          <div class="conbox">
            <div class="linebox fn-clear" v-for="(item,index) in history" :key="index">
              <div class="fl">
                <input type="text" placeholder="起止年月" v-model="item.time"
                @blur="fun('edus',item.time)"/>
              </div>
              <div class="fl">
                <input type="text" placeholder="校（院）、系及专业" v-model="item.school"
                @blur="fun('edus',item.school)"/>
              </div>
              <div class="fl">
                <input type="text" placeholder="学位" v-model="item.job"
                @blur="fun('edus',item.job)" />
              </div>
              <div class="fl">
                <a href="javascript:;" @click="add(index)">
                  <img src="./../assets/images/declare_icon_add@2x.png" alt />
                </a>
                <a href="javascript:;" @click="del(index)">
                  <img src="./../assets/images/declare_icon_delete@2x.png" alt />
                </a>
              </div>
            </div>
          </div>
        </div>
          <p class="tip" style="margin-left: 10px;
                                    margin-top: 5px;
                                    color: #d13d33;" v-show="historystate==false">请填写完整教育经历</p>
        <div class="formtit">
          <span class="icon arrow"></span>对申报项目的陈述
          <em>必填</em>
          <span class="desc">不超过300字</span>
        </div>
        <div class="descbox">
          <textarea
            name
            id
            cols="30"
            rows="10"
            placeholder="请输入"
            v-model="textarea.text"
            @blur="text()"
          ></textarea>
          <p class="tip" v-show="textarea.state==false">{{textarea.tiptxt}}</p>
        </div>
      </div>
      <div class="tiptxt">
        <img src="./../assets/images/-e-tip_icon_warn@2x.png" alt />郑重声明：本人承诺以上信息真实有效，并自愿遵守“基石奖”评选规则！
      </div>
      <div class="btnlist">
        <a href="javascript:;" class="btn2" @click="submit()">提交申请</a>
        <router-link to="/home" class="btn1">返回首页</router-link>
      </div>
    </div>
    <div class="footer-info fn-clear">
      <p class="logo fl">
        <img class="logo-site" src="./../assets/images/footer_logo@2x.png" />
      </p>
      <p class="copyright fr">Copyright © 1998 - 2020 ZhiShiFenZi. All Rights Reserved.</p>
    </div>
    <div class="tipbox" v-show="fadeinput">
      <img src="./../assets/images/-e-tip_icon_pass@2x.png" alt />申报成功！
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import myDatepicker from "vue-datepicker/vue-datepicker-es6.vue";
import {getApplyUrl} from "./../config/config.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { myDatepicker: myDatepicker },
  data() {
    //这里存放数据
    return {
      /* 表单内容 */
      tab: 1,
      xingbie: "",
      zhengjian: "",
      shenbaofangxiang: "",
      birthday:"",
      textarea: {
        text: "",
        state: true,
        tiptxt: "",
      },
      form: {
        zjxm: {
          desc: "" /* 存储输入内容 */,
          message: "专家姓名不能为空！" /* 返回 */,
          state: true /* 状态 */,
        },
        zjlxdh: {
          desc: "" /* 存储输入内容 */,
          message: "联系电话不能为空！" /* 返回 */,
          state: true /* 状态 */,
        },
        name: {
          desc: "" /* 存储输入内容 */,
          message: "姓名不能为空！" /* 返回 */,
          state: true /* 状态 */,
        },
        guoji: {
          desc: "" /* 存储输入内容 */,
          message: "国籍不能为空！" /* 返回 */,
          state: true /* 状态 */,
        },
        xingbie: {
          desc: "" /* 存储输入内容 */,
          message: "选择性别" /* 返回 */,
          state: true /* 状态 */,
        },
        zhengjian: {
          desc: "" /* 存储输入内容 */,
          message: "选择证件类型" /* 返回 */,
          state: true /* 状态 */,
        },
        zhengjianhaoma: {
          desc: "" /* 存储输入内容 */,
          message: "证件号码不能为空" /* 返回 */,
          state: true /* 状态 */,
        },
        xuexidanwei: {
          desc: "" /* 存储输入内容 */,
          message: "学习单位不能为空" /* 返回 */,
          state: true /* 状态 */,
        },
        zhuanye: {
          desc: "" /* 存储输入内容 */,
          message: "专业不能为空" /* 返回 */,
          state: true /* 状态 */,
        },
        zuigaoxuewei: {
          desc: "" /* 存储输入内容 */,
          message: "最高学位不能为空" /* 返回 */,
          state: true /* 状态 */,
        },
        shenbaofangxiang: {
          desc: "" /* 存储输入内容 */,
          message: "请选择申报方向" /* 返回 */,
          state: true /* 状态 */,
        },
        lianxidianhua: {
          desc: "" /* 存储输入内容 */,
          message: "联系电话不能为空" /* 返回 */,
          state: true /* 状态 */,
        },
        youxiang: {
          desc: "" /* 存储输入内容 */,
          message: "邮箱不能为空" /* 返回 */,
          state: true /* 状态 */,
        },
      },
      /* 提交成功弹框显示 */
      fadeinput: false,
      /* 时间选择器 */
      startTime: {
        // 默认的初始时间
        time: "2020-04-09",
      },
      historystate:true,
      /* 教育经历 */
      history: [
        {
          time: "",
          school: "",
          job: "",
        },
      ],
      timeoption: {
        type: "day", // day , multi-day //针对日期的限制，
        week: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        month: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        format: "YYYY-MM-DD", // YYYY-MM-DD 日期
        inputStyle: {
          // input 样式，可以进行自己的自定义修改，
          // display: "inline-block",
          // padding: ".1rem .05rem ",
          // "line-height": "1",
          // width: "1.5rem",
          // "font-size": "14px",
          // border: "1px solid #eeeeee",
          // "border-radius": "2px",
        },
        color: {
          // 字体颜色
          header: "#35acff", // 头部
          headerText: "#fff", // 头部文案
        },
        buttons: {
          // button 内容自定义
          ok: "确定",
          cancel: "取消",
        },
        overlayOpacity: 0.5, // 遮罩透明度
        placeholder: "请选时间", // 提示日期
        dismissible: false, // 默认true 待定
      },
      limit: [
        {
          //对时间区间的设定
          type: "weekday",
          available: [1, 2, 3, 4, 5, 6, 0],
        },
        {
          type: "fromto",
          from: "2016-02-01", //最早的开始时间
          to: "2020-04-09", //这个时间是我自己拼接出来的当前时间，也可以自己写入
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    xingbie(val, oldval) {
      console.log(val);
      if (val == "") {
        console.log(val);
        this.form.xingbie.state = false;
        this.form.xingbie.desc = val;
      } else {
        this.form.xingbie.state = true;
      }
    },
    zhengjian(val, oldval) {
      if (val == "") {
        this.form.zhengjian.state = false;
        this.form.zhengjian.desc = val;
      } else {
        this.form.zhengjian.state = true;
      }
    },
    shenbaofangxiang(val, oldval) {
      if (val == "") {
        this.form.shenbaofangxiang.state = false;
        this.form.shenbaofangxiang.desc = val;
      } else {
        this.form.shenbaofangxiang.state = true;
      }
    },
  },
  //方法集合
  methods: {
    text: function () {
      if (this.textarea.text.length > 300) {
        this.textarea.state = false;
        this.textarea.tiptxt = "不超过300字";
      } else if (this.textarea.text == "") {
        this.textarea.state = false;
        this.textarea.tiptxt = "请输入内容";
      } else {
        this.textarea.state = true;
      }
    },
    findItemNameBYClass: function (e) {
      console.log(e.target.value);
    },
    /* 时间改变回调 */
    changeTime(data) {
        this.birthday=data;
      console.log(data);
    },
    fun(name, con) {
      console.log(name);
      console.log(con);
      /* 如果姓名为空 */
      if (name == "edus") {
              if (con == "") {
                this.historystate = false;
              } else {
                this.historystate = true;
              }
      } else if (name == "name") {
        if (con == "") {
          this.form.name.state = false;
          console.log(this.form);
        } else {
          this.form.name.state = true;
          this.form.name.message = "";
        }
      } else if (name == "guoji") {
        if (con == "") {
          this.form.guoji.state = false;
          console.log(this.form);
        } else {
          this.form.guoji.state = true;
          this.form.guoji.message = "";
        }
      } else if (name == "zhengjianhaoma") {
        if (con == "") {
          this.form.zhengjianhaoma.state = false;
        } else {
          this.form.zhengjianhaoma.state = true;
          this.form.zhengjianhaoma.message = "";
        }
      } else if (name == "xuexidanwei") {
        if (con == "") {
          this.form.xuexidanwei.state = false;
        } else {
          this.form.xuexidanwei.state = true;
          this.form.xuexidanwei.message = "";
        }
      } else if (name == "zhuanye") {
        if (con == "") {
          this.form.zhuanye.state = false;
        } else {
          this.form.zhuanye.state = true;
          this.form.zhuanye.message = "";
        }
      } else if (name == "zuigaoxuewei") {
        if (con == "") {
          this.form.zuigaoxuewei.state = false;
        } else {
          this.form.zuigaoxuewei.state = true;
          this.form.zuigaoxuewei.message = "";
        }
      } else if (name == "lianxidianhua") {
        if (con == "") {
          this.form.lianxidianhua.state = false;
        } else {
          this.form.lianxidianhua.state = true;
          this.form.lianxidianhua.message = "";
        }
      } else if (name == "youxiang") {
        if (con == "") {
          this.form.youxiang.state = false;
        } else {
          this.form.youxiang.state = true;
          this.form.youxiang.message = "";
        }
      } else if (name == "zjxm") {
        if (con == "") {
          this.form.zjxm.state = false;
        } else {
          this.form.zjxm.state = true;
          this.form.zjxm.message = "";
        }
      } else if (name == "zjlxdh") {
        if (con == "") {
          this.form.zjlxdh.state = false;
        } else {
          this.form.zjlxdh.state = true;
          this.form.zjlxdh.message = "";
        }
      }
    },
    /* 表单提交 */
    submit() {
        var isCanApply = true;
      var _this = this;
      if (this.form.name.desc == "") {
        this.form.name.state = false;
        isCanApply = false;
      }
      if (this.form.guoji.desc == "") {
        this.form.guoji.state = false;
        isCanApply = false;
      }
      if (this.xingbie == "") {
        this.form.xingbie.state = false;
        isCanApply = false;
      }
      if (this.zhengjian == "") {
        this.form.zhengjian.state = false;
        isCanApply = false;
      }
      if (this.form.zhengjianhaoma.desc == "") {
        this.form.zhengjianhaoma.state = false;
        isCanApply = false;
      }
      if (this.form.zhengjianhaoma.desc == "") {
        this.form.zhengjianhaoma.state = false;
        isCanApply = false;
      }
      if (this.form.xuexidanwei.desc == "") {
        this.form.xuexidanwei.state = false;
        isCanApply = false;
      }
      if (this.form.zhuanye.desc == "") {
        this.form.zhuanye.state = false;
        isCanApply = false;
      }
      if (this.form.zuigaoxuewei.desc == "") {
        this.form.zuigaoxuewei.state = false;
        isCanApply = false;
      }
      if (this.shenbaofangxiang == "") {
        this.form.shenbaofangxiang.state = false;
        isCanApply = false;
      }
      if (this.form.lianxidianhua.desc == "") {
        this.form.lianxidianhua.state = false;
        isCanApply = false;
      }
      if (this.form.youxiang.desc == "") {
        this.form.youxiang.state = false;
        isCanApply = false;
      }
      if (this.textarea.text == "") {
        this.textarea.state = false;
        isCanApply = false;
      }
      if (this.tab == 1 && this.form.zjxm.desc == "") {
        this.form.zjxm.state = false;
        isCanApply = false;
      }
      if (this.tab == 1 && this.form.zjlxdh.desc == "") {
        this.form.zjlxdh.state = false;
        isCanApply = false;
      }
      var edus = [];
      this.history.forEach((element) => {
        var obj = {};
        obj.sedate = element.time;
        obj.school = element.school;
        obj.degree = element.job;
        edus.push(obj);
        if(element.time == "" || element.school == "" || element.job == ""){
            this.historystate = false;
            isCanApply = false;
        }
      });

      if(isCanApply){
        var reqdata = {};
        reqdata.edus = edus;
        reqdata.type = this.tab;
        reqdata.expertName = this.form.zjxm.desc;
        reqdata.expertPhone = this.form.zjlxdh.desc;
        reqdata.name = this.form.name.desc;
        reqdata.country = this.form.guoji.desc;
        reqdata.gender = this.form.xingbie.desc;
        reqdata.idtype = this.zhengjian;
        reqdata.idcard = this.form.zhengjianhaoma.desc;
        reqdata.studyCom = this.form.xuexidanwei.desc;
        reqdata.edu = this.form.zuigaoxuewei.desc;
        reqdata.major = this.form.zhuanye.desc;
        reqdata.applyOri = this.shenbaofangxiang;
        reqdata.phone = this.form.lianxidianhua.desc;
        reqdata.email = this.form.youxiang.desc;
        reqdata.content = this.textarea.text;
        reqdata.birthday = this.startTime.time;
        reqdata.gender = this.xingbie;

        this.$http({
                               method: "post",
                               url: getApplyUrl(),
                               data: reqdata,
                             }).then(rem => {
                                this.fadeinput = true;
                                   setInterval(function () {
                                     _this.fadeinput = false;
                                   }, 3000);
                             });
      }

    },
    /* 添加行 */
    add(event) {
      this.history.push({
        time: "",
        school: "",
        job: "",
      });
    },
    /* 删除行 */
    del(event) {
      if (this.history.length != 1) {
        this.history.splice(event, 1);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var mydate = new Date();
        var str = "" + mydate.getFullYear() + "-";
    //判断小于是是直接小于10月就可以了
        if(mydate.getMonth()<10){
            str +="0"+ (mydate.getMonth() + 1) + "-";
        }else{
            str += (mydate.getMonth() + 1) + "-";
        }
    //判断小于是是直接小于10日就可以了
        if(mydate.getDate()<10){
            str += "0"+mydate.getDate() + "";
        }else{
            str += mydate.getDate() + "";
        }
        this.startTime.time=str;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
@import url("./../assets/css/apply.css");
</style>